import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { PaisProvider, usePais } from "@/context/PaisContext";
import Inicio from "@/pages/Inicio";
import Planes from "@/pages/Planes";
import PlanWizard from "@/pages/PlanWizard";
import Empresas from "@/pages/Empresas";
import EmpresaDetail from "@/pages/EmpresaDetail";
import Configuracion from "@/pages/Configuracion";
import Formularios from "@/pages/Formularios";
import FormularioPublico from "@/pages/FormularioPublico";
import FormularioPublicoCH from "@/pages/FormularioPublicoCH";
import Recordatorios from "@/pages/Recordatorios";
import RecordatoriosEmpresa from "@/pages/RecordatoriosEmpresa";
import SeleccionarPais from "@/pages/SeleccionarPais";
import SuizaEmpresas from "@/pages/SuizaEmpresas";
import SuizaEmpresaDetalle from "@/pages/SuizaEmpresaDetalle";

function IndexRoute() {
  const { pais } = usePais();
  if (!pais) return <Navigate to="/seleccionar-pais" replace />;
  if (pais === "ch") return <Navigate to="/ch" replace />;
  return <Inicio />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PaisProvider>
          <Routes>
            <Route path="/seleccionar-pais" element={<SeleccionarPais />} />
            {/* España */}
            <Route path="/" element={<IndexRoute />} />
            <Route path="/planes" element={<Planes />} />
            <Route path="/planes/nuevo" element={<PlanWizard />} />
            <Route path="/planes/:id" element={<PlanWizard />} />
            <Route path="/empresas" element={<Empresas />} />
            <Route path="/empresas/:id" element={<EmpresaDetail />} />
            <Route path="/configuracion" element={<Configuracion />} />
            <Route path="/formularios" element={<Formularios />} />
            <Route path="/recordatorios" element={<Recordatorios />} />
            <Route path="/recordatorios/:empresaId" element={<RecordatoriosEmpresa />} />
            {/* Suiza */}
            <Route path="/ch" element={<SuizaEmpresas />} />
            <Route path="/ch/empresas/:id" element={<SuizaEmpresaDetalle />} />
            {/* Público */}
            <Route path="/f/:token" element={<FormularioPublico />} />
            <Route path="/ch/f/:token" element={<FormularioPublicoCH />} />
          </Routes>
        </PaisProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
